import { Box, BoxProps } from "@mui/material";
import LayoutProps from "@/src/_types/layout-props";
import PageContentBox
    from "@/src/components/journal-site/common/page-content/mui-custom/page-content-box/page-content-box";

const PageContent = ({children, ...props}: LayoutProps & BoxProps) => {
    return (
        <Box style={{zIndex: 10}} {...props}>
            <PageContentBox p={3}>
                {children}
            </PageContentBox>
        </Box>
    )
}

export default PageContent
